import { produce } from 'immer';

import { CreateInternalProduct } from '../../../actions/products/internal/createInternalProduct';
import { ProductsPageStates, ProductsState } from '../../../typings/products';

export function createInternalProduct(state: ProductsState, action: CreateInternalProduct): ProductsState {
    return produce(state, draft => {
        draft.pageStatus = ProductsPageStates.FETCH_FORM;
    });
}
